<template>
  <div class="list" >
    <div
      v-for="(item, index) in items"
      :id="`url-${random}-${index}`"
      :key="index"
      class="list-item flex flex-align-center show-hand"
      :class="{
        'status-200': item.status_code && parseInt(item.status_code) && parseInt(item.status_code) >= 200 && parseInt(item.status_code) < 300,
        'status-400': item.status_code && parseInt(item.status_code) && parseInt(item.status_code) >= 400 && parseInt(item.status_code) < 500,
      }"
      @click="openUrl(item.url)" >
      <SBIcon
        v-if="item.status_code && parseInt(item.status_code) && parseInt(item.status_code) >= 200 && parseInt(item.status_code) < 300"
        class="mr-2"
        :icon="SBIconList.FOLDER_TICK"
        :color="SBColors.blackPrimary"
        :size="14" />
      <SBIcon
        v-else-if="item.status_code && parseInt(item.status_code) && parseInt(item.status_code) >= 400 && parseInt(item.status_code) < 500"
        class="mr-2"
        :icon="SBIconList.CLOSE_THIN"
        :color="SBColors.greyLight"
        :size="14" />
      <SBIcon
        v-else
        class="mr-2"
        :icon="SBIconList.TRIANGLE_EXCLAMATION"
        :color="SBColors.redPrimary"
        :size="14" />
      <p class="greedy ellipsis">{{ item.url }}</p>
      <SBIcon
        v-if="!readOnly"
        class="ml-2"
        :icon="SBIconList.TRASH"
        :color="SBColors.blackUltralight"
        :hover-icon-color="SBColors.blackPrimary"
        :hover-size="24"
        :size="14"
        pointer
        @click.native="removeCallback($event, item)" />
      <b-popover
        v-if="item.status_code && parseInt(item.status_code) && parseInt(item.status_code) >= 400"
        :target="`url-${random}-${index}`"
        triggers="hover"
        placement="top"
        custom-class="basic-popover flex-body"
        boundary="viewport" >
        {{ item.status_code && parseInt(item.status_code) && (parseInt(item.status_code) < 500) ? 'This web page doesn\'t exist.' : 'This web page could not be scraped.' }}
      </b-popover>
    </div>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import randomString from '@/helpers/randomString';

export default {
  name: 'UrlList',
  components: {
    SBIcon,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: true,
    },
    removeCallback: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
      random: randomString(),
    };
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.list-item {
  p {
    font-size: 14px;
    font-weight: normal;
    color: $redPrimary;
  }

  &.status-200 p {
    color: $blackPrimary;
  }

  &.status-400 p {
    color: $greyLight;
  }

  &.status-failed * {
    color: $redPrimary;
  }
}
</style>
